import Table from "../Utils/Grid";
import React, { Component } from 'react';
import { BreakLine } from '../Utils/tableOptions';
import CustomToolbar from '../Utils/Toolbar/CustomToolbar';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import NumberFormat from "react-number-format";
import { api } from 'api';
import Swal from 'sweetalert2';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

class Messaging extends Component {

    state = {
        fechaInicial: this.props.initial_date,
        fechaFinal: this.props.final_date,
        replyMessage: null,
        replyBody: '',
        sending: false,
    };

    componentWillMount() {
      this.props.listMessages();
    }

    setFechaInicial(value) {
        this.setState({ fechaInicial: value });
    }

    setFechaFinal(value) {
        this.setState({ fechaFinal: value });
    }

    existeFecha(fecha) {
        var fechaf = fecha.split("/");
        var d = fechaf[0];
        var m = fechaf[1];
        var y = fechaf[2];
        return m > 0 && m < 13 && y > 1900 && y < 32768 && d > 0 && d <= (new Date(y, m, 0)).getDate();
    }

    openReply(message) {
        this.setState({ replyMessage: message, replyBody: '' });
    }

    closeReply() {
        this.setState({ replyMessage: null, replyBody: '' });
    }

    sendReply() {
        const { replyMessage, replyBody } = this.state;
        if (!replyMessage) return;
        if (!replyBody.trim()) {
            Swal('Error', 'El mensaje no puede estar vacío.', 'error');
            return;
        }
        this.setState({ sending: true });
        api.post('messaging/sendMessage', {
            msisdn: replyMessage.msisdn,
            body: replyBody.trim(),
        }).then(() => {
            this.setState({ sending: false, replyMessage: null, replyBody: '' });
            Swal('Éxito', 'Mensaje enviado correctamente.', 'success');
            this.props.listMessages();
        }).catch((error) => {
            this.setState({ sending: false });
            Swal('Error', (error && error.detail) || 'Ha ocurrido un error, por favor vuelva a intentar.', 'error');
        });
    }

    render() {
        const {
            listMessages,
            setInitialDate,
            setFinalDate,
            filterType,
        } = this.props;

        const {
            cargando,
            page,
            data,
            filter_type_list,
        } = this.props;

        return (
            <div className="content pt-3">
                <div className="m-auto row-fluid w-100">
                    <div className="table-decoration">
                    <div className="d-flex flex-row justify-content-around align-items-center flex-wrap">

                    <div className="d-flex flex-row justify-content-around align-items-center flex-wrap">
                        <div className="top-title-toolbar mt-3 d-flex">
                            <span className="ml-2 text-uppercase text-titulo"><strong>MENSAJERÍA</strong></span>
                        </div>

                        <div style={{width: 150}} className='mr-2'>
                        <Select
                            className={"w-100"}
                            onChange={(e) => {
                              filterType(e.value);
                            }}
                            classNamePrefix="react-select"
                            defaultOptions
                            theme={(theme) => {
                                return {
                                    ...theme,
                                    borderRadius: '1em',
                                    background: 'white',
                                    colors: {
                                        ...theme.colors,
                                        text: '#415362',
                                        primary25: '#ebebeb',
                                        primary: '#0a5995',
                                    },
                                }
                            }}

                            searchPromptText="Escriba para buscar" valueKey={'id'} labelKey={'name'}
                            options={filter_type_list}
                        />
                        </div>
                        <div className='d-flex flex-row w-30 mr-2'>
                        <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                            className="form-control w-50"
                            value={this.state.fechaInicial}
                            onValueChange={(values) => {
                                if(this.existeFecha(values.formattedValue)){
                                    this.setFechaInicial(values.formattedValue);
                                    setInitialDate(values.formattedValue);
                                }
                            }}
                            autoFocus
                            onFocus={(e) => {
                                e.target.setSelectionRange(0,10);
                            }}
                            onKeyUp={(ev) => {
                                if(ev.keyCode === 13 && this.existeFecha(this.state.fechaInicial)){
                                    setInitialDate(this.state.fechaInicial);
                                }
                            }}
                        />

                        <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                            className="form-control w-50 ml-2 mr-2"
                            value={this.state.fechaFinal}
                            onValueChange={(values) => {
                                if(this.existeFecha(values.formattedValue)){
                                    this.setFechaFinal(values.formattedValue)
                                    setFinalDate(values.formattedValue)
                                }
                            }}

                            onFocus={(e) => {
                                e.target.setSelectionRange(0,10);
                            }}
                            onKeyUp={(ev) => {
                                if(ev.keyCode === 13 && this.existeFecha(this.state.fechaFinal)){
                                    setFinalDate(this.state.fechaFinal);
                                }
                            }}
                        />
                        </div>
                    <div className="top-title-toolbar mt-3">
                        <CustomToolbar
                            //buscar={this.props.search}
                            //buscador={this.props.buscador}
                            date = {{
                                setInitialDate: setInitialDate,
                                fechaInicial: this.state.fechaInicial,
                                setFinalDate: setFinalDate,
                                fechaFinal: this.state.fechaFinal,
                            }}
                            autofocus
                        />
                    </div>
                    </div>
                    </div>

                        <Table
                            onPageChange={listMessages}
                            data={data}
                            loading={cargando}
                            page={page}
                        >
                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="id"
                                dataSort
                                isKey={true}
                                >Id</TableHeaderColumn>
                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="msisdn"
                                dataSort
                                >Número</TableHeaderColumn>
                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField="body"
                                dataSort
                                >Mensaje</TableHeaderColumn>

                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField='createdDate'
                                dataFormat={(cell)=>{
                                    return cell
                                }}
                                dataSort>Fecha y Hora</TableHeaderColumn>

<TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField='flow'
                                dataSort
                                dataFormat={(cell)=>{
                                    if(cell == 1){
                                        return 'Recibido';
                                    }else{
                                        return 'Enviado';
                                    }
                                }}
                            >Enviado al IGSS</TableHeaderColumn>

                            <TableHeaderColumn
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                dataField='id'
                                dataFormat={(cell, row) => (
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={() => this.openReply(row)}
                                    >
                                        Responder
                                    </button>
                                )}
                            >Acciones</TableHeaderColumn>
                        </Table>

                        <Modal isOpen={!!this.state.replyMessage} toggle={() => this.closeReply()}>
                            <ModalHeader toggle={() => this.closeReply()}>Responder mensaje</ModalHeader>
                            <ModalBody>
                                {this.state.replyMessage && (
                                    <div>
                                        <p><strong>Para:</strong> {this.state.replyMessage.msisdn}</p>
                                        <p><strong>Mensaje original:</strong></p>
                        <p className="bg-light p-2 rounded">{this.state.replyMessage.body}</p>
                                        <label><strong>Respuesta:</strong></label>
                                        <textarea
                                            className="form-control"
                                            style={{ width: '100%', borderRadius: '0.25rem', borderColor: '#ced4da' }}
                                            rows={4}
                                            value={this.state.replyBody}
                                            onChange={(e) => this.setState({ replyBody: e.target.value })}
                                            placeholder="Escriba su respuesta..."
                                        />
                                    </div>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <button className="btn btn-secondary" onClick={() => this.closeReply()} disabled={this.state.sending}>Cancelar</button>
                                <button className="btn btn-primary" onClick={() => this.sendReply()} disabled={this.state.sending}>
                                    {this.state.sending ? 'Enviando...' : 'Enviar'}
                                </button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

export default Messaging;
